<template>
    <div>
        <!-- <Sound /> -->
        <Menu :data="data" />
        <Player />
        <div id="animation-nav">
            <Nav :color="color" />
        </div>
        <div id="page" v-bind:class="{active : page}" v-show="!$store.state.menuStatus">
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </div>
        <div id="home" v-bind:class="{active : page}">
            <div class="editions-wrap">
                <!-- <div v-for="(item, key) in data" :key="item.ID" class="edition-wrap" :style="'color:'+ item.acf.color"> -->
                <div class="edition-wrap" :style="'color:'+ item.acf.color" v-if="data">
                    <Edition :item="item" :status="false" :num="selected"></Edition>
                </div>
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Nav from './Nav'
import Edition from './Edition'
// import Sound from './Sound'
import Player from './Player'
import Menu from './Menu'

// import Animation from './Animation'
import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';


export default {
    name: 'Home',
    data() {
        return {
            data: null,
            pending: true,
            error: null,
            selected: 0
        }
    },
    components: {
        Nav,
        Edition,
        Player,
        Menu
        // Sound
    },
    computed: {
        page() {
            return this.$store.state.isPage;
        },
        color() {

            if (!this.slug) {
                return "#000";
            } else {
                if (this.item && this.item.acf && this.item.acf.color) {
                    return this.item.acf.color;
                } else {
                    return "#000";
                }
            }

        },
        slug() {
            return this.$route.params.slug;
        },
        item() {
            if (this.slug && this.data) {
                return this.data.find(
                    edition => edition.post_name === this.slug
                );
            } else {
                if (this.data) {
                    return this.data[0];

                } else {
                    return null;
                }
            }
        },

    },
    mounted() {
        this.requestData()
    },
    methods: {
        async requestData() {
            this.pending = true
            try {
                const { data } = await axios.get(`${this.$store.state.api}/get_editions`, { params: { id: 'home' } })
                this.data = data;
                this.error = false;
            } catch (e) {
                this.data = null;
                this.error = e;
            }
            this.pending = false;
        },
    },
    watch: {
        slug(n, o) {
            this.$store.commit('setIsPage', false)
        },
        $route(to) {
            let self = this;
            document.querySelector("#page").scrollTop = 0;

            (to.path == '/') ? this.$store.commit('setIsPage', false): '';
            (to.path == '/echoes') ? this.$store.commit('setIsPage', true): '';


            if (to.path == '/artists') {
                this.$store.commit('setIsPage', true)
                var sounds = document.getElementsByTagName('audio');
                for (let i = 0; i < sounds.length; i++) {
                    sounds[i].pause();
                    sounds[i].currentTime = 0;
                }
            }

            this.$store.commit('setPage', to.path)



        }
    }
}
</script>
<style lang="scss">
</style>